
import { Component, ElementRef, OnInit } from '@angular/core';
import { PageBase } from 't4core';
@Component({
  styleUrls: ['./DetachedBluetoothLocks.css'],
  selector: 'DetachedBluetoothLocks',
  templateUrl: './DetachedBluetoothLocks.component.html',
})
export class DetachedBluetoothLocks extends PageBase implements OnInit{

    constructor(el: ElementRef) {
      super(el, "DetachedBluetoothLocks");
  }


  public locksWithSub;
  public detachedLocks;
  public activeSubscription;

  public async ngOnInit() {

    var token = this.UI.beginLoading("T4.Service.DetachedLocks.ldrLoadingLocks", "Loading locks", null);

    const currentTime = new Date();
    const formattedTime = currentTime.toISOString().replace('T', ' ').slice(0, 19);

    this.detachedLocks = await this.Api.get<any>("DataService/GetReport", { reportName: 'DetachedBluetoothLockStatus', from: formattedTime, to: formattedTime });
    this.locksWithSub = await this.Api.get<any>("DataService/GetReport", { reportName: 'DetachedLockWithSub', from: formattedTime, to: formattedTime });

    this.UI.loaderCompleted(token);
  }
}
